import { Queue } from '@mui/icons-material';
import { IconButton, Menu, Tooltip } from '@mui/material';
import { useContextMenu } from 'kineticUtils/hooks';

import { WORKSPACES_PAGE_ROUTE } from 'const/routes';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { PageWorkspacesMenu } from './PageWorkspacesMenu';
import useDocumentationButtonStyles from './styles';
import { CloneWorkspaceMenu } from './CloneWorkspaceMenu';

type WorkspaceButtonProps = {
  pageTitle: string;
};

export const WorkspaceButton = ({ pageTitle }: WorkspaceButtonProps) => {
  const { t } = useTranslation('workspace');
  const classes = useDocumentationButtonStyles();

  const {
    props: menuProps,
    handleOpenMenu: openMenu,
    handleCloseMenu: closeMenu,
  } = useContextMenu({
    anchorOrigin: { horizontal: 'center', vertical: 'center' },
    transformOrigin: { horizontal: 'right', vertical: 'top' },
  });

  const location = useLocation();
  const isWorkspacePage = location.pathname.includes(WORKSPACES_PAGE_ROUTE);

  return (
    <>
      <Tooltip title={isWorkspacePage ? t('cloneWorkspace') : t('addToWorkspace')}>
        <IconButton
          id='new_workspace-button'
          style={{ fontSize: 'inherit' }}
          onClick={openMenu}
          className={classes.button}
        >
          <Queue fontSize='small' />
        </IconButton>
      </Tooltip>
      <Menu
        id='layerExtentPrefMenu'
        {...menuProps}
        onClose={closeMenu}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            closeMenu();
          }
        }}
      >
        {isWorkspacePage ? (
          <CloneWorkspaceMenu onClose={closeMenu} />
        ) : (
          <PageWorkspacesMenu pageTitle={pageTitle} />
        )}
      </Menu>
    </>
  );
};
